import data from "../data/nearbyguide.json";

export const getSiteStats = () => {
  const cityCount = Object.keys(data.cities || {}).length;
  const categoryCount = Object.keys(data.categories || {}).length;

  let totalPlaces = 0;

  Object.values(data.cities || {}).forEach((city) => {
    Object.values(city).forEach((categoryList) => {
      if (Array.isArray(categoryList)) {
        totalPlaces += categoryList.length;
      }
    });
  });

  return {
    cities: cityCount,
    categories: categoryCount,
    places: totalPlaces,
  };
};
